import { render } from "./GooglePayButton.vue?vue&type=template&id=5cfcb685"
import script from "./GooglePayButton.vue?vue&type=script&lang=js"
export * from "./GooglePayButton.vue?vue&type=script&lang=js"

import "./GooglePayButton.vue?vue&type=style&index=0&id=5cfcb685&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__